import React from 'react';
import { Link } from 'react-router-dom';
import Board from '../components/Board';
import { PageHeader, NextMove, useTitle } from '../components/Layout';
import { useProgress, useVisit } from '../progress';
import { fromFen } from '../chess';
import { scenarios } from '../data';

export const puzzleNumber = (scenario) => String(scenarios.indexOf(scenario) + 1).padStart(2, '0');

export default function Puzzles() {
  useTitle('Puzzles');
  useVisit('puzzles');
  const { puzzleState, puzzlesDone } = useProgress();

  return (
    <div className="page">
      <PageHeader index="03" eyebrow="Puzzles" title="Real problems, set as puzzles.">
        Eight business challenges I have faced, each paired with a mate-in-one. Solve the position to unlock my
        approach and the result, or just reveal the move.
      </PageHeader>

      <p className="puzzle-progress muted">
        <span className="mono">
          {puzzlesDone}/{scenarios.length}
        </span>{' '}
        completed
      </p>

      <div className="puzzle-grid">
        {scenarios.map((s) => {
          const state = puzzleState(s.id);
          return (
            <Link key={s.id} to={`/puzzles/${s.id}`} className="puzzle-card">
              <div className="puzzle-thumb">
                <Board position={fromFen(s.fen)} showCoords={false} ariaLabel={`Puzzle ${puzzleNumber(s)} position`} className="board-mini" />
              </div>
              <div className="puzzle-body">
                <div className="row-between puzzle-meta">
                  <span className="eyebrow">
                    <span className="mono">#{puzzleNumber(s)}</span> · {s.theme}
                  </span>
                  {state && <span className={`status-pill is-${state}`}>{state === 'solved' ? '✓ Solved' : 'Revealed'}</span>}
                </div>
                <p className="puzzle-company">
                  {s.company} {s.location && <span className="muted">· {s.location}</span>}
                </p>
                <h2 className="puzzle-title">{s.title}</h2>
                <p className="puzzle-preview">{s.preview}</p>
                <ul className="chips">
                  {s.tags.map((t) => (
                    <li key={t} className="chip">
                      {t}
                    </li>
                  ))}
                </ul>
              </div>
            </Link>
          );
        })}
      </div>

      <NextMove current="/puzzles" />
    </div>
  );
}
